// extracted by mini-css-extract-plugin
module.exports = {"logo3c":"style__logo3c__avLBq","primary":"style__primary__cS2qK","secondary":"style__secondary__VAUfz","logo":"style__logo__ndN7L"};